///sso/tagImage/getTagsImageTreeList
import request from './axios'
//图库-图片标签列表
export function getGalleryTagList(data) {
  return request({
    url: `/lx/sso/tagImage/getTagsImageTreeList`,//`/lx/sso/tagImage/getTagsImageTreeList`,
    method: 'post',
    data
  })
}

//图库-图片列表
export function getGalleryList(data) {
  return request({
    url: `/lx/fodder/image-item/admin/page`,
    method: 'post',
    data
  })
}
export function getGalleryShow() {
  return request({
    url: `/lx/fodder/image/checkViewGalleryPermission`,
    method: 'get'
  })
}
export function getGertShow() {
  return request({
    url: `/lx/certificate/checkCertificatePermission`,
    method: 'get'
  })
}
